export default "__VITE_ASSET__DDCjD$Tk__"